import * as yup from 'yup';

export enum SupportedAuthProvidersEnum {
  Google = 'google.com',
  Microsoft = 'microsoft.com',
  JaneStreet = 'saml.jane-street',
  Pace = 'saml.pace',
  Vercel = 'saml.vercel',
  Deel = 'saml.deel',
  ConsumerReports = 'saml.consumer-reports',
  Keysight = 'saml.keysight',
  Docusign = 'saml.docusign',
  ImprintEngine = 'saml.imprint-engine',
}

export enum SupportedTenantsEnum {
  JaneStreet = 'janestreet',
  Pace = 'pace',
  Vercel = 'vercel',
  Deel = 'deel',
  ConsumerReports = 'consumer-reports',
  Keysight = 'keysight',
  Docusign = 'docusign',
  ImprintEngine = 'imprint-engine',
}

export const LOGIN_FORM_VALIDATION_SCHEMA = yup.object().shape({
  email: yup.string().required(),
});

export const LOGIN_FORM_INITIAL_VALUES = {
  email: '',
};

export const ERROR_LINK_CREDENTIALS_IS_NEEDED = 'auth/account-exists-with-different-credential';

export const INVALID_CREDENTIALS_MESSAGE = 'Email or password is incorrect';

export const INVALID_CREDENTIALS_ERROR_CODES = [
  'auth/user-not-found',
  'auth/wrong-password',
  'auth/invalid-credential',
  'auth/invalid-login-credentials',
  'auth/invalid-email',
];

export const EXISTING_ACCOUNT_MESSAGE =
  'This email is already associated with an account. Sign in using the provider associated with this email.';

export const MAGIC_LINK_EMAIL_STORAGE_KEY = 'magicLinkEmail';

export const LOGIN_CONTENT_MAX_WIDTH = 400;

// Codes that mean the link itself is dead — retrying with a different email won't help.
// Source: firebase-js-sdk packages/auth/src/core/errors.ts (EXPIRED_OOB_CODE, INVALID_OOB_CODE, USER_DISABLED).
export const MAGIC_LINK_EXPIRED_ERROR_CODES: readonly string[] = [
  'auth/expired-action-code',
  'auth/invalid-action-code',
  'auth/user-disabled',
];

// Fired by signInWithEmailLink when the supplied email doesn't match what the link was issued for,
// or is malformed. Recoverable by re-typing in the cross-device branch.
// Source: firebase-js-sdk packages/auth/src/core/errors.ts (INVALID_EMAIL).
export const MAGIC_LINK_EMAIL_MISMATCH_ERROR_CODE = 'auth/invalid-email';
